import { createContext } from 'react';

const UserFeaturesContext = createContext({
        userFeatures: null,
        saveUserFeatures: () => {},
        OFCSpeciality: null,
        saveOFCSpeciality: () => {}
});

export default UserFeaturesContext;